export default __webpack_public_path__ + "static/media/skype.c8d7ee17.png";